function useComboboxDropdownStyle(_ref) {
  var highlighted = _ref.highlighted,
      size = _ref.size,
      hasCheckIcon = _ref.hasCheckIcon,
      checked = _ref.checked;
  var buttonStyle = {
    fullWidth: true,
    group: 'group',
    appearance: 'ghost',
    padding: size === 'sm' ? ['px-2', 'py-0'] : ['px-3', 'py-1'],
    justifyContent: 'justify-start',
    fontSize: size === 'sm' ? 'text-sm' : 'text-base',
    fontWeight: 'font-normal',
    lineHeight: 'leading-normal',
    backgroundColor: highlighted ? 'bg-blue-500' : undefined,
    textColor: highlighted ? 'text-white' : 'text-gray-500',
    transitionDuration: 'duration-75',
    textAlign: 'text-left'
  };
  var textStyle = {
    truncate: true,
    padding: hasCheckIcon && !checked ? 'pl-6' : undefined
  };
  return {
    buttonStyle: buttonStyle,
    textStyle: textStyle
  };
}

export { useComboboxDropdownStyle };
//# sourceMappingURL=use-combobox-dropdown-style.esm.js.map
